if($('#component-application-tags').length){
    var app = new Vue({
        el: '#component-application-tags',
        data: {
            model:polymorphicModel,
            modelId:polymorphicId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationTags:[],
            availableTags:[],
            tagText:''
        },
        methods: {
            getCurrentTags(){
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.model+'/'+this.modelId+'/tags').then((response) =>  {
                    this.applicationTags = response.data;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getAvailableTags(){
                axios.post('/api/v1/network/'+this.networkSlug+'/'+this.model+'/'+this.modelId+'/tags/search', {name:this.tagText}).then((response) =>  {
                    this.availableTags = response.data;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            tagInput: _.debounce(function (e) {
                if(this.tagText){
                    this.getAvailableTags();
                }else{
                    this.availableTags = [];
                }
            }, 500),
            addNewTag(){
                if(this.tagText){
                    axios.post('/api/v1/network/'+this.networkSlug+'/'+this.model+'/'+this.modelId+'/tags', {name:this.tagText}).then((response) =>  {
                        this.availableTags = [];
                        this.tagText = '';
                        this.getCurrentTags();
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }
            },
            removeTag(id){
                axios.delete('/api/v1/network/'+this.networkSlug+'/'+this.model+'/'+this.modelId+'/tags/'+id).then((response) =>  {
                    this.getCurrentTags();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            selectTag(text){
                this.tagText = text;
                this.addNewTag();
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        mounted () {
            this.getCurrentTags();
        }
    });
}